module.exports = __webpack_public_path__ + "static/media/PAPINA_MENU-normal.7ff12a1f.png";